import { Routes } from '@angular/router';
import { integratorGuard } from './core/guards/integrator.guard';
import { editAppGuard } from './core/guards/edit-app.guard';
import { NavigationSetup } from './core/services/navigation-items-service/navigation-setup';
import { isNotOnMobileGuard } from './core/guards/is-not-on-mobile.guard';
import { editCollectionGuard } from './core/guards/edit-collection.guard';
import { NotFoundPageComponent } from './core/components/error-page/custom-error-pages/not-found-page/not-found-page.component';
import { ErrorPageComponent } from './core/components/error-page/error-page.component';
import {
  AuthenticationErrorPageComponent
} from './core/components/error-page/custom-error-pages/authentication-error-page/authentication-error-page.component';
import {
  authenticationErrorPageGuard
} from './core/guards/authentication-error-page.guard';

export const routes: Routes = [
  {
    path: NavigationSetup.START_PAGE.path,
    loadComponent: () =>
      import('./pages/start-page/start-page.component').then((c) => c.StartPageComponent),
    data: {
      pureStartPage: true,
    }
  },
  {
    path: NavigationSetup.APP_FINDER.path,
    loadComponent: () =>
      import('./pages/finder/finder.component').then((c) => c.FinderComponent),
  },
  {
    path: NavigationSetup.APP_DETAIL_PAGE.path,
    loadComponent: () =>
      import('./pages/app-details-page/app-details-page.component').then(
        (c) => c.AppDetailsPageComponent,
      ),
  },
  {
    path: NavigationSetup.APP_MANAGER_PAGE.path,
    loadComponent: () =>
      import('./pages/manager/manager.component').then((c) => c.ManagerComponent),
    canActivate: [isNotOnMobileGuard],
  },
  {
    path: NavigationSetup.COLLECTION_DETAIL_PAGE.path,
    loadComponent: () =>
      import('./pages/collection-detail-page/collection-detail-page.component').then(
        (c) => c.CollectionDetailPageComponent,
      ),
  },
  {
    path: NavigationSetup.ADMIN_UI_PAGE.path,
    loadComponent: () =>
      import('./pages/app-admin-ui-page/app-admin-ui-page.component').then(
        (c) => c.AppAdminUiPageComponent,
      ),
    canActivate: [isNotOnMobileGuard],
  },
  {
    path: NavigationSetup.APP_INTEGRATOR_PAGE.path,
    children: [
      {
        path: '',
        redirectTo: NavigationSetup.CREATE_APP.path,
        pathMatch: 'full',
      },
      {
        path: NavigationSetup.CREATE_APP.path,
        loadComponent: () =>
          import('./pages/app-integrator-page/integrator.component').then(
            (c) => c.IntegratorComponent,
          ),
      },
      {
        path: NavigationSetup.EDIT_APP.path,
        loadComponent: () =>
          import('./pages/app-integrator-page/integrator.component').then(
            (c) => c.IntegratorComponent,
          ),
        canActivate: [editAppGuard],
      },
      {
        path: '**',
        redirectTo: NavigationSetup.CREATE_APP.path,
        pathMatch: 'full',
      },
    ],
    canActivate: [integratorGuard],
  },
  {
    path: NavigationSetup.COLLECTION_INTEGRATOR_PAGE.path,
    children: [
      {
        path: '',
        redirectTo: NavigationSetup.CREATE_COLLECTION.path,
        pathMatch: 'full',
      },
      {
        path: NavigationSetup.CREATE_COLLECTION.path,
        loadComponent: () =>
          import('./pages/collection-integrator-page/collection-integrator-page.component').then(
            (c) => c.CollectionIntegratorPageComponent,
          ),
      },
      {
        path: NavigationSetup.EDIT_COLLECTION.path,
        loadComponent: () =>
          import('./pages/collection-integrator-page/collection-integrator-page.component').then(
            (c) => c.CollectionIntegratorPageComponent,
          ),
        canActivate: [editCollectionGuard],
      },
      {
        path: '**',
        redirectTo: NavigationSetup.CREATE_COLLECTION.path,
        pathMatch: 'full',
      },
    ],
    canActivate: [integratorGuard],
  },
  {
    path: NavigationSetup.LAUNCHPAD_IMPORT_PAGE.path,
    loadComponent: () =>
      import('./pages/launchpad-import/launchpad-import.component').then(
        (c) => c.LaunchpadImportComponent,
      ),
  },
  {
    path: NavigationSetup.PIN_APP.path,
    loadComponent: () =>
      import('./pages/start-page/start-page.component').then(
        (c) => c.StartPageComponent,
      ),
    data: {
      itemTypeForAutoAdd: 'app',
    }
  },
  {
    path: NavigationSetup.PIN_COLLECTION.path,
    loadComponent: () =>
      import('./pages/start-page/start-page.component').then(
        (c) => c.StartPageComponent,
      ),
    data: {
      itemTypeForAutoAdd: 'collection',
    }
  },
  {
    path: NavigationSetup.MINIWIDGET_PAGE.path,
    loadComponent: () =>
      import('./pages/settings/mini-widget/mini-widget-settings.component').then(
        (c) => c.MiniWidgetSettingsComponent,
      ),
    canActivate: [isNotOnMobileGuard],
  },
  {
    path: NavigationSetup.LAUNCH_APP.path,
    loadComponent: () =>
      import('./pages/app-launch/app-launch.component').then(c=> c.AppLaunchComponent)
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    children: [
      { path: '404', component: NotFoundPageComponent },
      {
        path: '401',
        component: AuthenticationErrorPageComponent,
        canActivate: [authenticationErrorPageGuard],
      }
    ],
  },
  { path: '**', redirectTo: '/error/404' },
];
